function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#pure_to_pure);}.cls-2{fill:url(#pure_to_pure-2);}.cls-3{fill:url(#pure_to_pure-3);}.cls-4{fill:url(#pure_to_pure-4);}.cls-5{fill:url(#pure_to_pure-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure",
  x1: 124.63,
  y1: 225.08,
  x2: 270.33,
  y2: 225.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1fc3f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4cbfac"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-2",
  x1: 124.63,
  y1: 153.83,
  x2: 270.33,
  y2: 153.83,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-3",
  x1: 124.63,
  y1: 288.14,
  x2: 270.33,
  y2: 288.14,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-4",
  x1: 124.63,
  y1: 288.17,
  x2: 270.33,
  y2: 288.17,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-5",
  x1: 124.63,
  y1: 469.22,
  x2: 270.33,
  y2: 469.22,
  xlinkHref: "#pure_to_pure"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M425.88,208.92V92.2c0-39.81-30.8-72.2-68.64-72.2H142.77c-37.85,0-68.65,32.39-68.65,72.2V208.92c0,93.69,62.45,172.19,148.5,186.64l6.76.94v33.67h41.24V396.54l5.25-.76C361.39,382.24,425.88,301.91,425.88,208.92ZM272.14,372.29a140.65,140.65,0,0,1-45.58-.2C152,359.57,97.92,290.94,97.92,208.92V92.2c0-26.69,20.12-48.41,44.85-48.41H357.24c24.72,0,44.84,21.72,44.84,48.41V208.92C402.08,290.32,346.22,360.55,272.14,372.29Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M335.15,87.25H164.85A29.88,29.88,0,0,0,135,117.09v73.47a29.88,29.88,0,0,0,29.85,29.85h170.3A29.88,29.88,0,0,0,365,190.56V117.09A29.87,29.87,0,0,0,335.15,87.25Zm11.58,103.31a11.58,11.58,0,0,1-11.58,11.57H164.85a11.58,11.58,0,0,1-11.58-11.57V117.09a11.58,11.58,0,0,1,11.58-11.56h170.3a11.58,11.58,0,0,1,11.58,11.56Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M192.67,290.73,228,311.5a3.1,3.1,0,0,0,4.67-2.64l.31-41.4a3.1,3.1,0,0,0-4.65-2.7l-35.68,20.61A3.1,3.1,0,0,0,192.67,290.73Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M271.61,311.35l35.64-20.22a3.1,3.1,0,0,0,0-5.37L272,265a3.1,3.1,0,0,0-4.67,2.65l-.3,41A3.1,3.1,0,0,0,271.61,311.35Z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 229.38,
  y: 458.45,
  width: 41.24,
  height: 21.55
});

var SvgIconGlucometer = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGlucometer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_glucometer.2e3c8080.svg";
export { ForwardRef as ReactComponent };